export const DynamicCharacteristicsTableHeadings = {
	PAC_BETA_TO_CUSTOM_BENCHMARK: 'Beta to $customBenchmark$'
};

export const DynamicCharacteristicsInfoBubbles = {
	PAC_BETA_TO_CUSTOM_BENCHMARK_INFO_BUBBLE: 'Beta to $customBenchmark$'
};

